import * as React from 'react'
import './animation.css'
type StringOrNumber = number | string;
type Offset = StringOrNumber[];
export type msgProps = React.ReactNode;
export interface LoadingProps {
  className?: string

  /**
     * 自定义加载文案
     */
  msg?: msgProps;

  /**
     * root根节点类名 仅在 isModal 为 true 时生效
     */
  rootClassName?: string;

  /**
     * loading位置偏移
     * @default [0,0]
     */
  offset?: Offset;

  /**
     * 显示隐藏
     * @default true
     */
  visible?: boolean;

  /**
     * 是否是全屏的弹层模式展示
     * @default true
     */
  isModal?: boolean;

  /**
     * 自定义icon
     */
  iconNode?: React.ReactNode;

  /**
     * 是否展示loadingIcon
     * @default true
     */
  showLoadingIcon?: boolean;
}
export interface ThemeProps {
  loading: string;
  'loading-container': string;
}

export type InputProps = msgProps | LoadingProps;

let iconElement: React.ReactNode

export const defaultProps: LoadingProps = {
  msg: '',
  className: '',
  rootClassName: '',
  offset: [0, 0],
  visible: true,
  isModal: true,
  showLoadingIcon: true,
}

class Comp extends React.Component<LoadingProps, object> {
  static show: (props: msgProps|LoadingProps) => void

  static hide: () => void

  renderIconNode (): React.ReactNode {
    const {
      className,
      msg,
      iconNode,
      showLoadingIcon = true,
    } = this.props
    return (
      <div
        className={'self-loading-fullscreen'}
      >
        <div className={'self-loading-container'}>
          {showLoadingIcon && (iconNode || this.renderIcon())}
          {msg ? <div className={'self-loading-tip'}>{msg}</div> : null}
        </div>
      </div>
    )
  }


  renderIcon (): React.ReactNode {
    if (iconElement) return iconElement
    const dotList = [] as any
    for (let index = 0; index < 12; index++) {
      dotList.push(
        <div
          key={`dot-${index}`}
          className={`self-loading-item${index} self-loading-item`}
        />
      )
    }
    iconElement = (
      <div className={'self-loading-icon'}>
        {dotList}
      </div>
    )
    return iconElement
  }

  render () {
    const {
      msg,
      isModal,
      iconNode,
      showLoadingIcon,
    } = this.props
    if (!isModal) {
      return this.renderIconNode()
    }
    return (<div className={'loading'}>
      {showLoadingIcon && (iconNode || this.renderIcon())}
      {msg ? <div className={'loading-tip'}>{msg}</div> : null}
    </div>
    )
  }
}

export default Comp